export default {
	widgetUserEvent: [
		{
			logic: ({ eventData }) => {
				const { action, element, result } = eventData;

				return (
					action === 'clicked' &&
					element === 'Save button' &&
					result === 'Vehicle saved'
				);
			},
			payload: ({ eventData }) => {
				const { isVlp } = window.DDC.dataLayer.page.pageInfo;

				const { make, model, year } = eventData?.vehicle || {};

				const nameplate = `${make} ${model}`;

				const payload = {
					onclick: {
						onclick: `{inventoryType}:si:${
							isVlp ? 'vls' : 'vehicle details'
						}:content:save`,
						onclickLinkName: `{inventoryType}:si:${
							isVlp ? 'vls' : 'vehicle details'
						}:content:action:${nameplate}`
					},
					vehicle: {
						modelYear: year,
						nameplate
					}
				};

				return {
					payload
				};
			}
		},
		{
			logic: ({ eventData }) => {
				const { action, result } = eventData;

				return (
					action === 'clicked' &&
					result === 'Email Signup for Price Alert Notifications'
				);
			},
			payload: ({ eventData }) => {
				const { make, model, year } = eventData?.vehicle || {};

				const nameplate = `${make} ${model}`;

				const payload = {
					event: {
						action: 'updates opt-in'
					},
					user: {
						leadOptIn: 'email direct opt-in'
					},
					vehicle: {
						modelYear: year,
						nameplate
					}
				};

				return {
					directCall: 'price-watch-complete',
					payload
				};
			}
		}
	]
};
